/* src/app/header/header-notifications/header-notifications.component.scss */
div {
  display: flex;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0 5px;
}
div > i {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  align-items: center;
}
/*# sourceMappingURL=header-notifications.component.css.map */
